module.exports = __webpack_public_path__ + "media/images/401playlogo-5f18083f9d2465fab1ccbcdefbdb5f05.jpeg";